export default class DefaultDetailsSerializer {
  getDetails() {
    return [];
  }
}
